import React from 'react';

export default function CatchError(component) {
  return class extends React.Component {
    state = { errorStatus: undefined };

    render() {
      return component(this.props, this.state.errorStatus);
    }
  };
}
